import { ArrowLeft, Search, Package, RotateCcw, ArrowRight, Plus, Currency, ArrowBigDownIcon } from "lucide-react";
import "./warehouseN.css";
import { io } from "socket.io-client";
import { useState, useEffect, useMemo, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Template from "../../../Template";
import WarehouseSkeleton from "../../../../components/uxCollections/skeletonLoader/SkeletonLoader";
import WarehouseNameandInfo from "../WarehouseNameandInfo";
import { useDispatch, useSelector } from "react-redux";
import { dropWarehouse, setWarehouse } from "../../../../slice/warehouseSlice";
import { createProductUrl, getWarehouseUrl, moveToStoreUrl } from "../../../../api/endpoints";
import { ButtonLoader, ButtonLoaderII } from "../../../../components/uxCollections/Loaders";
import RestockOverlay from "../../stockManagement/RestockNI";
import AddStockPage from "../../stockManagement/AddStockPage";
import { AiOutlineArrowDown, AiOutlineArrowUp } from "react-icons/ai";
import { ModalAlert } from "../../../../components/alerts/modalAlert";
import AddProductByPhoto from "../../stockManagement/addProductwithAuto/AIProductAdd/AddProductByAI";
import AddStockModal from "../../stockManagement/addProductwithAuto/AddStockModal";
import { toast } from "sonner";
import AddStockViaExcel from "../../stockManagement/addStockCSVExcel/AddStockwithExcelAndCSV";
import { uiAlert } from "../../../../components/alerts/customAlert/uiAlert";
import ProductManageModal from "./EditModal";
import "./MoveProductOverlay.css";

const WarehouseManagementPage = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const [activeTab, setActiveTab] = useState("management");
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  /* old state */
  const socket = useMemo(() => io(process.env.REACT_APP_Back_end_api_root, { transports: ["websocket"] }), []); /* auth can be provided */
  const [restockModal, setRestockModal] = useState(false);
  const [page, setPage] = useState("warehouseStock");
  const [productsInWarehouse, setProductsInWarehouse] = useState([]);
  const [warehouseHistory, setWarehouseHistory] = useState([]);
  const [filterKeyWords, setFilterKeyWords] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [moveToStore, setMoveToStore] = useState(false);
  const [alertDisplay, setAlertDisplay] = useState({
    showAlert: false,
    type: "",
    title: "",
    message: "",
  });
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [openEditModal, setOpenEditModal] = useState(false);
  const [openAddProductModal, setOpenAddProductModal] = useState(false);
  const { wareHouseID } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const warehouse = useSelector((state) => state.warehouse.warehouse);
  const currency = useSelector((state) => state.webStoreUser.userCountryCurrencySymbol || "₦");

  useEffect(() => {
    //join the socket room for the warehouse
    socket.on("connect", () => {
      console.log(socket.id); // x8WIv7-mJelg7on_ALbx
      socket.emit("createRoom", wareHouseID);
    });
    fetchWarehouse();
    return () => {
      socket.off("connect");
      socket.disconnect();
    };
  }, []);

  useEffect(() => {
    console.log("inwarehouse", warehouse.productsInWarehouse);
    setProductsInWarehouse(warehouse.productsInWarehouse);
    setWarehouseHistory(warehouse.warehouseHistory);
  }, [warehouse]);

  const fetchWarehouse = async () => {
    try {
      let response = await fetch(getWarehouseUrl + wareHouseID, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
      });
      if (response.ok) {
        const warehouse = await response.json();
        dispatch(setWarehouse(warehouse));
        setProductsInWarehouse(warehouse.productsInWarehouse);
        setWarehouseHistory(warehouse.warehouseHistory);
        setIsLoading(false);
      }
    } catch (error) {
      console.log(error);
      uiAlert("An error occurred while fetching warehouse data", "error");
    }
  };

  const stockData = [
    {
      id: 1,
      picture: null,
      createdOn: "2025-09-28",
      name: "Us material",
      brand: "hs",
      costPrice: 67000,
      available: 700,
      restock: false,
    },
  ];

  return (
    <Template>
      {isLoading ? (
        <WarehouseSkeleton />
      ) : (
        <div className='stockmgmt-container'>
          <WarehouseNameandInfo warehouse={warehouse} />
          {page === "warehouseStock" && (
            <>
              <header className='stockmgmt-header'>
                <div className='stockmgmt-top-row'>
                  <div className='stockmgmt-nav-left'>
                    <button
                      className='stockmgmt-back-btn'
                      onClick={() => {
                        navigate("/mystores");
                        dispatch(dropWarehouse());
                      }}
                    >
                      <ArrowLeft size={16} />
                      back to stores
                    </button>
                  </div>
                  <div className='stockmgmt-nav-right'>
                    <div className='stockmgmt-search-container'>
                      <Search className='stockmgmt-search-icon' size={16} />
                      <input
                        type='text'
                        placeholder='Enter product name'
                        className='stockmgmt-search-input'
                        value={filterKeyWords}
                        onChange={(e) => setFilterKeyWords(e.target.value)}
                      />
                    </div>
                    <button className='stockmgmt-search-btn' onClick={() => setIsSearchOpen(!isSearchOpen)}>
                      <Search size={16} />
                      Search
                    </button>
                  </div>
                </div>

                <div className='stockmgmt-tabs-container'>
                  <div className='stockmgmt-tabs'>
                    <button className={`stockmgmt-tab ${activeTab === "management" ? "active" : ""}`} onClick={() => setActiveTab("management")}>
                      Stock Management
                    </button>
                    <button className={`stockmgmt-tab ${activeTab === "history" ? "active" : ""}`} onClick={() => setActiveTab("history")}>
                      Stock History
                    </button>
                  </div>
                </div>

                {/* <div className={`stockmgmt-mobile-search ${isSearchOpen ? "open" : ""}`}>
                    <div style={{ position: "relative" }}>
                      <Search className='stockmgmt-search-icon' size={16} />
                      <input
                        type='text'
                        placeholder='Enter order ID'
                        className='stockmgmt-mobile-search-input'
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                        autoFocus={isSearchOpen}
                      />
                    </div>
                  </div> */}
              </header>

              {activeTab === "management" ? (
                <main className='stockmgmt-main-content'>
                  {/* Desktop Table View */}
                  <div className='stockmgmt-table-container'>
                    <table className='stockmgmt-table'>
                      <thead className='stockmgmt-table-header'>
                        <tr>
                          <th>Picture</th>
                          <th>Created on</th>
                          <th>Name</th>
                          <th>Brand</th>
                          <th>Cost price ({currency})</th>
                          <th>Available</th>
                          <th>Restock</th>
                          <th>Move to store</th>
                        </tr>
                      </thead>
                      <tbody>
                        {productsInWarehouse && productsInWarehouse.length > 0 ? (
                          productsInWarehouse
                            .filter((filteredProducts) => filteredProducts.name.toLowerCase().includes(filterKeyWords.toLowerCase()))
                            .slice()
                            .reverse()
                            .map((product, index) => (
                              <tr
                                onClick={() => {
                                  setSelectedProduct(product);
                                  setOpenEditModal(true);
                                }}
                                key={product._id}
                                className='stockmgmt-table-row'
                              >
                                <td className='stockmgmt-picture-cell'>
                                  <div className='stockmgmt-product-image'>
                                    <Package size={20} />
                                  </div>
                                </td>
                                <td>{product.creationDate?.split("T")[0]}</td>
                                <td className='stockmgmt-product-name'>{product.name}</td>
                                <td className='stockmgmt-brand'>{product.brand}</td>
                                <td className='stockmgmt-price'>{product.costPrice.toLocaleString()}</td>
                                <td>
                                  <span className='stockmgmt-stock-count'>{product.quantity}</span>
                                </td>
                                <td
                                  className='stockmgmt-restock-indicator'
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    setSelectedProduct(product);
                                    setRestockModal(true);
                                  }}
                                >
                                  <RotateCcw className='stockmgmt-restock-icon' size={18} />
                                </td>
                                <td>
                                  <button
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      setSelectedProduct(product);
                                      setMoveToStore(true);
                                    }}
                                    className='stockmgmt-move-btn'
                                    disabled={product.quantity === 0 || isLoading} /* disable move button if quantity is 0 */
                                  >
                                    Move <ArrowRight size={14} />
                                  </button>
                                </td>
                              </tr>
                            ))
                        ) : (
                          <p className='noStockInWarehouse'>No stock in warehouse</p>
                        )}
                      </tbody>
                    </table>
                  </div>

                  {/* Mobile Cards View */}
                  <div className='stockmgmt-mobile-cards'>
                    {productsInWarehouse && productsInWarehouse.length > 0 ? (
                      productsInWarehouse
                        .filter((filteredProducts) => filteredProducts.name.toLowerCase().includes(filterKeyWords.toLowerCase()))
                        .slice()
                        .reverse()
                        .map((product, index) => (
                          <div
                            onClick={() => {
                              setSelectedProduct(product);
                              setOpenEditModal(true);
                            }}
                            key={`mobile-${product._id}`}
                            className='stockmgmt-mobile-card'
                          >
                            <div className='stockmgmt-mobile-card-header'>
                              <div className='stockmgmt-mobile-card-left'>
                                <div className='stockmgmt-mobile-card-image'>
                                  <Package size={24} />
                                </div>
                                <div className='stockmgmt-mobile-card-title'>
                                  <div className='stockmgmt-mobile-card-name'>{product.name}</div>
                                  <div className='stockmgmt-mobile-card-brand'>{product.brand}</div>
                                </div>
                              </div>
                              <div className='stockmgmt-mobile-card-right'>
                                <div className='stockmgmt-mobile-card-available-label'>Available</div>
                                <span className='stockmgmt-mobile-card-stock'>{product.quantity}</span>
                              </div>
                            </div>

                            <div className='stockmgmt-mobile-card-content'>
                              <div className='stockmgmt-mobile-card-field'>
                                <div className='stockmgmt-mobile-card-label'>Created On</div>
                                <div className='stockmgmt-mobile-card-value stockmgmt-mobile-card-date'>{product.creationDate?.split("T")[0]}</div>
                              </div>
                              <div className='stockmgmt-mobile-card-field'>
                                <div className='stockmgmt-mobile-card-label'>Cost Price</div>
                                <div className='stockmgmt-mobile-card-value stockmgmt-mobile-card-price'>
                                  {currency} {product.costPrice.toLocaleString()}
                                </div>
                              </div>
                            </div>

                            <div className='stockmgmt-mobile-card-actions'>
                              <div
                                className='stockmgmt-mobile-card-restock'
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setSelectedProduct(product);
                                  setRestockModal(true);
                                }}
                              >
                                <RotateCcw className='stockmgmt-restock-icon' size={18} />
                              </div>
                              <button
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setSelectedProduct(product);
                                  setMoveToStore(true);
                                }}
                                className='stockmgmt-mobile-card-move'
                                disabled={product.quantity === 0 || isLoading} /* disable move button if quantity is 0 */
                              >
                                Move to Store <ArrowRight size={16} />
                              </button>
                            </div>
                          </div>
                        ))
                    ) : (
                      <p className='noStockInWarehouse'>No stock in warehouse</p>
                    )}
                  </div>

                  <div className='stockmgmt-footer-notice'>
                    <strong>Note:</strong> Stocks added in the warehouse are not Available in the market place. They can only be moved to outlet stores
                  </div>

                  <button
                    onClick={() => {
                      // setPage("addStock");
                      setOpenAddProductModal(true);
                    }}
                    className='stockmgmt-fixed-add-btn'
                  >
                    <Plus size={20} />
                    Add stock
                  </button>
                </main>
              ) : (
                <main className='stockmgmt-main-content'>
                  {/* Desktop Table View */}
                  <div className='stockmgmt-table-container'>
                    <table className='stockmgmt-table'>
                      <thead className='stockmgmt-table-header'>
                        <tr>
                          <th>Picture</th>
                          <th>Created on</th>
                          <th>Name</th>
                          <th>Brand</th>
                          <th>Cost price ({currency})</th>
                          <th>Quantity</th>
                          <th>Date</th>
                          <th>Activities</th>
                        </tr>
                      </thead>
                      <tbody>
                        {warehouseHistory && warehouseHistory.length > 0 ? (
                          warehouseHistory
                            .filter((history) => history.productName.toLowerCase().includes(filterKeyWords.toLowerCase()))
                            .slice()
                            .reverse()
                            .map((history, index) => (
                              <>
                                <tr key={index} className='stockmgmt-table-row'>
                                  <td className='stockmgmt-picture-cell'>
                                    <div className='stockmgmt-product-image'>
                                      <Package size={20} />
                                    </div>
                                  </td>
                                  <td>{history.productCreationDate?.split("T")[0]}</td>
                                  <td className='stockmgmt-product-name'>{history.productName}</td>
                                  <td className='stockmgmt-brand'>{history.productBrand}</td>
                                  <td className='stockmgmt-price'>{history.productCostPrice.toLocaleString()}</td>
                                  <td>
                                    <span
                                      style={{ color: history.activity.split(" ")[0] === "Moved" ? "#EC7D0F" : "#5CCB4B" }}
                                      className='stockmgmt-stock-count'
                                    >
                                      {history.quantity}
                                    </span>
                                  </td>
                                  <td
                                    style={{ color: history.activity.split(" ")[0] === "Moved" ? "#EC7D0F" : "#5CCB4B" }}
                                    className='stockmgmt-restock-indicator'
                                  >
                                    {history.dateOfActivity.split("T")[0]}
                                  </td>
                                  <td>
                                    <p style={{ color: history.activity.split(" ")[0] === "Moved" ? "#EC7D0F" : "#5CCB4B" }}>
                                      {history.activity}{" "}
                                      {history.activity.split(" ")[0] === "Moved" ? <AiOutlineArrowUp size={18} /> : <AiOutlineArrowDown size={18} />}{" "}
                                    </p>
                                  </td>
                                </tr>
                              </>
                            ))
                        ) : (
                          <p className='noStockInWarehouse'>No History yet</p>
                        )}
                      </tbody>
                    </table>
                  </div>

                  {/* Mobile Cards View */}
                  <div className='stockmgmt-mobile-cards'>
                    {warehouseHistory && warehouseHistory.length > 0 ? (
                      warehouseHistory
                        .filter((history) => history.productName.toLowerCase().includes(filterKeyWords.toLowerCase()))
                        .slice()
                        .reverse()
                        .map((history, index) => (
                          <>
                            <div key={`mobile-${index}`} className='stockmgmt-mobile-card'>
                              <div className='stockmgmt-mobile-card-header'>
                                <div className='stockmgmt-mobile-card-left'>
                                  <div className='stockmgmt-mobile-card-image'>
                                    <Package size={24} />
                                  </div>
                                  <div className='stockmgmt-mobile-card-title'>
                                    <div className='stockmgmt-mobile-card-name'>{history.productName}</div>
                                    <div className='stockmgmt-mobile-card-brand'>{history.productBrand}</div>
                                  </div>
                                </div>
                                <div className='stockmgmt-mobile-card-right'>
                                  <div className='stockmgmt-mobile-card-available-label'>Quantity</div>
                                  <span className='stockmgmt-mobile-card-stock'>{history.quantity}</span>
                                </div>
                              </div>

                              <div className='stockmgmt-mobile-card-content'>
                                <div className='stockmgmt-mobile-card-field'>
                                  <div className='stockmgmt-mobile-card-label'>Activity date</div>
                                  <div className='stockmgmt-mobile-card-value stockmgmt-mobile-card-date'>{history.dateOfActivity.split("T")[0]}</div>
                                </div>
                                <div className='stockmgmt-mobile-card-field'>
                                  <div className='stockmgmt-mobile-card-label'>Cost Price</div>
                                  <div className='stockmgmt-mobile-card-value stockmgmt-mobile-card-price'>
                                    {currency} {history.productCostPrice.toLocaleString()}
                                  </div>
                                </div>
                              </div>

                              <div className='stockmgmt-mobile-card-actions'>
                                <div
                                  style={{ backgroundColor: history.activity.split(" ")[0] === "Moved" ? "rgb(255, 240, 180)" : "rgb(212, 255, 215)" }}
                                  className='stockmgmt-mobile-card-restock'
                                >
                                  {/*  <RotateCcw className='stockmgmt-restock-icon' size={18} /> */}
                                  {history.activity.split(" ")[0] === "Moved" ? (
                                    <AiOutlineArrowUp
                                      color={history.activity.split(" ")[0] === "Moved" ? "#EC7D0F" : "#5CCB4B"}
                                      className='stockmgmt-restock-icon'
                                      size={18}
                                    />
                                  ) : (
                                    <AiOutlineArrowDown
                                      color={history.activity.split(" ")[0] === "Moved" ? "#EC7D0F" : "#5CCB4B"}
                                      className='stockmgmt-restock-icon'
                                      size={18}
                                    />
                                  )}{" "}
                                </div>
                                <div
                                  style={{
                                    color: history.activity.split(" ")[0] === "Moved" ? "#B45309" : "#15803D",
                                    fontWeight: "600",
                                    textAlign: "center",
                                    backgroundColor: history.activity.split(" ")[0] === "Moved" ? "rgb(255, 242, 190)" : "rgb(200, 254, 204)",
                                  }}
                                  className='stockmgmt-mobile-card-move'
                                >
                                  {history.activity}
                                </div>
                              </div>
                            </div>
                          </>
                        ))
                    ) : (
                      <p className='noStockInWarehouse'>No History yet</p>
                    )}
                  </div>

                  <button className='stockmgmt-fixed-add-btn'>
                    <ArrowBigDownIcon size={20} />
                    <span className='downloadHistortBtn'>Download history</span>
                  </button>
                </main>
              )}
            </>
          )}
          {page === "addStock" && <AddStockPage changePage={setPage} warehouse={true} socket={socket} productLists={productsInWarehouse} />}

          {page === "addProductWithAI" && <AddProductByPhoto changePage={setPage} warehouse={true} setAlertDisplay={setAlertDisplay} socket={socket} />}

          {page === "addProductWithExcel" && <AddStockViaExcel changePage={setPage} warehouse={true} setAlertDisplay={setAlertDisplay} socket={socket} />}

          {openAddProductModal && (
            <AddStockModal
              isOpen={openAddProductModal}
              onClose={() => {
                setOpenAddProductModal(false);
              }}
              onManualEntry={() => {
                setPage("addStock");
              }}
              onFileUpload={() => {
                setPage("addProductWithExcel");
              }}
              onAIPhotoScan={() => {
                console.log("AI photo scan clicked");
                setPage("addProductWithAI");
              }}
            />
          )}
          {moveToStore && (
            <MoveProductOverlay
              product={selectedProduct}
              onClose={() => {
                setMoveToStore(false);
                setSelectedProduct(null);
              }}
              warehouseID={warehouse._id}
              currency={currency}
            />
          )}
          {/* {moveToStore && <MovedToStoreModal product={selectedProduct} setMoveToStore={setMoveToStore} warehouseID={warehouse._id} currency={currency} />} */}
          {restockModal && <RestockOverlay refreshData={fetchWarehouse} product={selectedProduct} closeModal={setRestockModal} />}
          {openEditModal && (
            <ProductManageModal
              isOpen={openEditModal}
              product={selectedProduct}
              onClose={() => {
                setOpenEditModal(false);
                setSelectedProduct(null);
              }}
              currency={currency}
              onUpdate={(fetchWarehouse) => {
                setProductsInWarehouse(fetchWarehouse.productsInWarehouse);
                setWarehouseHistory(fetchWarehouse.warehouseHistory);
              }}
            />
          )}
          <ModalAlert
            type={alertDisplay.type}
            showAlert={alertDisplay.showAlert}
            title={alertDisplay.title}
            message={alertDisplay.message}
            setAlertDisplay={setAlertDisplay}
          />
        </div>
      )}
    </Template>
  );
};

export default WarehouseManagementPage;

const STEPS = { FORM: "FORM", REVIEW: "REVIEW", SUCCESS: "SUCCESS" };
// Normalize text
const normalize = (str) =>
  String(str || "")
    .toLowerCase()
    .replace(/[^a-z0-9\s]/g, "")
    .trim();

// Simple similarity (token-based)
const similarityScore = (a, b) => {
  const aWords = new Set(normalize(a).split(/\s+/));
  const bWords = new Set(normalize(b).split(/\s+/));

  if (!aWords.size || !bWords.size) return 0;

  let matchCount = 0;

  for (let word of aWords) {
    if (bWords.has(word)) matchCount++;
  }

  return matchCount / Math.max(aWords.size, bWords.size);
};

export const findMatchingProducts = (products, targetName, targetBrand) => {
  return products.filter((product) => {
    const nameScore = similarityScore(product.name, targetName);
    const brandScore = similarityScore(product.brand, targetBrand);

    // weight name higher than brand
    const finalScore = nameScore * 0.7 + brandScore * 0.3;

    return finalScore >= 0.7;
  });
};

export function MoveProductOverlay({ product, onClose, warehouseID, currency, onMove }) {
  const [step, setStep] = useState(STEPS.FORM);
  const [selectedStoreId, setSelectedStoreId] = useState("");
  const [quantity, setQuantity] = useState("");
  const [matches, setMatches] = useState([]);
  const [selectedMatchId, setSelectedMatchId] = useState(null);
  const [choice, setChoice] = useState(null); // "restock" | "create"
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const { user } = useSelector((state) => state.webStoreUser);
  const stores = user?.store || [];

  const dispatch = useDispatch();

  // available stock is amountInWarehouse (falls back to quantity)
  const availableQty = product.amountInWarehouse ?? product.quantity ?? 0;
  const selectedStore = stores.find((s) => s._id === selectedStoreId);

  async function handleCheckStore() {
    setError("");
    const qty = parseInt(quantity, 10);
    if (!selectedStoreId) return setError("Please select a destination store.");
    if (!qty || qty <= 0) return setError("Enter a valid quantity.");
    if (qty > availableQty) return setError(`Only ${availableQty} units available in warehouse.`);

    setLoading(true);
    try {
      const storeProducts = await getStoreProducts(selectedStoreId);
      /*  const found = (storeProducts || []).filter(
        (p) => p.name?.toLowerCase() === product.name?.toLowerCase()
      ); */
      const found = findMatchingProducts(storeProducts || [], product.name, product.brand);
      setMatches(found);
      setChoice(found.length > 0 ? null : "create");
      setSelectedMatchId(found.length === 1 ? found[0]._id : null);
      setStep(STEPS.REVIEW);
    } catch (err) {
      setError("Failed to fetch store products. Please try again.");
    } finally {
      setLoading(false);
    }
  }

  const getStoreProducts = async (storeId) => {
    let accessToken = localStorage.getItem("accessToken");
    try {
      let response = await fetch(createProductUrl + storeId, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      });
      if (response.status === 404) {
        uiAlert("Store not found", "error");
        return [];
      }

      if (response.ok) {
        let storeProductCollection = await response.json();

        return storeProductCollection.products;
      }
    } catch (error) {
      console.log(error);
      uiAlert("An error occurred, please try again later", "error");
    }
  };

  async function handleMove() {
    /* 
    two senerios
    1. restock existing product in store: choice = "restock", target = matched product in store
    2. create new product in store: choice = "create", target = null
    
    */
    try {
      setLoading(true);
      const qty = parseInt(quantity, 10);
      const target = choice === "restock" ? matches.find((m) => m._id === selectedMatchId) : null;
      /*   onMove?.({ product, qty, store: selectedStore, choice, target });
      setStep(STEPS.SUCCESS); */

      const payload = {
        product,
        storeMovedToID: selectedStore._id,
        quantity: qty,
        storeMovedToName: selectedStore.storeName,
        employee: null,
        productToRestockID: target?._id,
      };

      let response = await fetch(moveToStoreUrl + warehouseID + "/?moveIntention=" + choice, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
        body: JSON.stringify(payload),
      });
      const data = await response.json();

      if (response.status === 404 || response.status === 403) {
        return uiAlert(data.message, "error");
      }
      if (response.ok) {
        dispatch(setWarehouse(data));
        uiAlert("Product moved to store successfully", "success");
        setSelectedMatchId(null);

        setStep(STEPS.SUCCESS);
        return;
      }

      throw new Error("Failed to move product to store");
    } catch (error) {
      console.log(error);
      uiAlert("An error occurred while moving product to store", "error");
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className='mpo-backdrop' onClick={(e) => e.target === e.currentTarget && onClose()}>
      <div className='mpo-card'>
        {/* ── STEP 1: FORM ── */}
        {step === STEPS.FORM && (
          <>
            <div className='mpo-header'>
              <h2 className='mpo-header-title'>Move product</h2>
              <button className='mpo-close-btn' onClick={onClose}>
                ×
              </button>
            </div>

            <ProductChip product={product} availableQty={availableQty} currency={currency} />

            <div className='mpo-field'>
              <label className='mpo-label'>Destination store</label>
              <select className='mpo-select' value={selectedStoreId} onChange={(e) => setSelectedStoreId(e.target.value)}>
                <option value=''>Select store</option>
                {user?.store?.map((s) => (
                  <option key={s._id} value={s._id}>
                    {s.storeName}
                  </option>
                ))}
              </select>
            </div>

            <div className='mpo-field'>
              <label className='mpo-label'>Quantity to move</label>
              <input
                className='mpo-input'
                type='number'
                min={1}
                max={availableQty}
                placeholder='Enter quantity to move'
                value={quantity}
                onChange={(e) => setQuantity(e.target.value)}
              />
            </div>

            <p className='mpo-error-text'>{error}</p>

            <button className='mpo-btn-primary' onClick={handleCheckStore} disabled={loading}>
              {loading ? "Checking..." : "Move"}
            </button>
          </>
        )}

        {/* ── STEP 2: REVIEW ── */}
        {step === STEPS.REVIEW && (
          <>
            <div className='mpo-back-header'>
              <button className='mpo-back-btn' onClick={() => setStep(STEPS.FORM)}>
                <svg width='20' height='20' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2'>
                  <path d='M15 18l-6-6 6-6' />
                </svg>
              </button>
              <h2 className='mpo-header-title'>Review move</h2>
            </div>

            <div className='mpo-summary-bar'>
              <span>
                Moving <b>{quantity} units</b> of <b>{product.name}</b>
              </span>
              <span className='mpo-summary-dest'>→ {selectedStore?.storeName}</span>
            </div>

            {matches.length > 0 ? (
              <>
                {/* Warning */}
                <div className='mpo-warn-banner'>
                  <svg width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='#b45309' strokeWidth='2' style={{ flexShrink: 0, marginTop: 2 }}>
                    <path d='M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z' />
                    <line x1='12' y1='9' x2='12' y2='13' />
                    <line x1='12' y1='17' x2='12.01' y2='17' />
                  </svg>
                  <p className='mpo-warn-banner-text'>
                    {matches.length === 1
                      ? `A duplicate was found in ${selectedStore?.storeName} with the same or similar name and brand.`
                      : `${matches.length} duplicates found in ${selectedStore?.storeName} with the same name and brand.`}{" "}
                    Select one to restock or create a new product entry.
                  </p>
                </div>

                {/* Existing matches */}
                <p className='mpo-match-label'>Existing matches</p>

                {matches.map((m) => {
                  const active = choice === "restock" && selectedMatchId === m._id;
                  return (
                    <div
                      key={m._id}
                      className={`mpo-radio-row${active ? " mpo-radio-row--active" : ""}`}
                      onClick={() => {
                        setChoice("restock");
                        setSelectedMatchId(m._id);
                      }}
                    >
                      <div className='mpo-radio-row-info'>
                        <p className='mpo-radio-row-name'>{m.name}</p>
                        <p className='mpo-radio-row-sub'>
                          {(m.quantity ?? 0).toLocaleString("en-NG")} in stock
                          {m.costPrice ? ` · ₦${m.costPrice.toLocaleString("en-NG")}` : ""}
                          {m.brand && m.brand !== "Unknown Brand" ? ` · ${m.brand}` : ""}
                        </p>
                      </div>
                      <div className='mpo-radio-ring'>{active && <div className='mpo-radio-dot' />}</div>
                    </div>
                  );
                })}

                {/* Create new option */}
                <div
                  className={`mpo-radio-row${choice === "create" ? " mpo-radio-row--active" : ""}`}
                  onClick={() => {
                    setChoice("create");
                    setSelectedMatchId(null);
                  }}
                >
                  <div className='mpo-radio-row-info'>
                    <p className='mpo-radio-row-name'>Create as new product</p>
                    <p className='mpo-radio-row-sub'>Add as a separate product entry even though a match exists</p>
                  </div>
                  <div className='mpo-radio-ring'>{choice === "create" && <div className='mpo-radio-dot' />}</div>
                </div>
              </>
            ) : (
              /* No duplicates */
              <div className='mpo-nodupe-banner'>
                <svg width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='#166534' strokeWidth='2' style={{ flexShrink: 0, marginTop: 2 }}>
                  <path d='M22 11.08V12a10 10 0 11-5.93-9.14' />
                  <polyline points='22 4 12 14.01 9 11.01' />
                </svg>
                <p className='mpo-nodupe-banner-text'>No duplicates found in {selectedStore?.storeName}. This product will be created fresh in the store.</p>
              </div>
            )}

            <button className='mpo-btn-primary' onClick={handleMove} disabled={(matches.length > 0 && !choice) || loading}>
              {loading ? <ButtonLoaderII /> : choice === "restock" ? "Restock existing product" : "Create new product & move"}
            </button>
            <button className='mpo-btn-secondary' onClick={onClose}>
              Cancel
            </button>
          </>
        )}

        {/* ── STEP 3: SUCCESS ── */}
        {step === STEPS.SUCCESS && (
          <div className='mpo-success-step'>
            <div className='mpo-success-icon-wrap'>
              <svg width='28' height='28' viewBox='0 0 24 24' fill='none' stroke='#16a34a' strokeWidth='2'>
                <path d='M22 11.08V12a10 10 0 11-5.93-9.14' />
                <polyline points='22 4 12 14.01 9 11.01' />
              </svg>
            </div>
            <h2 className='mpo-success-step-title'>Move successful</h2>
            <p className='mpo-success-step-msg'>
              <b>{quantity} units</b> of <b>{product.name}</b> moved to <b>{selectedStore?.storeName}</b>
              {choice === "restock" ? " and restocked to the existing product." : ", added as a new product in the store."}
            </p>
            <button className='mpo-btn-primary' onClick={onClose}>
              Done
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

/* ── Internal: product chip ── */
function ProductChip({ product: p, availableQty, currency }) {
  const imageUrl = Array.isArray(p.productImage) ? p.productImage[0] : (p.productImage ?? null);

  return (
    <div className='mpo-product-chip'>
      <div className='mpo-product-img-box'>
        {imageUrl ? (
          <img src={imageUrl} alt={p.name} />
        ) : (
          <svg width='22' height='22' viewBox='0 0 24 24' fill='none' stroke='#94a3b8' strokeWidth='1.5'>
            <rect x='3' y='3' width='18' height='18' rx='2' />
            <path d='M3 9h18M9 21V9' />
          </svg>
        )}
      </div>

      <div className='mpo-product-info'>
        <p className='mpo-product-name'>{p.name}</p>
        <p className='mpo-product-meta'>
          {currency}
          {p.costPrice?.toLocaleString("en-NG")} cost
          {p.brand && p.brand !== "Unknown Brand" ? ` · ${p.brand}` : ""}
          {p.productCategory ? ` · ${p.productCategory}` : ""}
        </p>
      </div>

      <div className='mpo-product-avail-block'>
        <span className='mpo-product-avail-qty'>{availableQty.toLocaleString("en-NG")}</span>
        <span className='mpo-product-avail-label'>Available</span>
      </div>
    </div>
  );
}
